import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-unsupported',
  template: `<div class="todo-item">todo ({{ fieldConfig.type }})</div>`,
  styles: [
    `
      .todo-item {
        color: red;
      }
    `,
  ],
  standalone: false,
})
export class UnsupportedFormFieldComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  ngOnDestroy() {}
}
